import { render, staticRenderFns } from "./Gynls.vue?vue&type=template&id=55def810&scoped=true&"
import script from "./Gynls.vue?vue&type=script&lang=js&"
export * from "./Gynls.vue?vue&type=script&lang=js&"
import style0 from "./Gynls.vue?vue&type=style&index=0&id=55def810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55def810",
  null
  
)

export default component.exports